<template>
  <div style="background-color: white; width: 100%;">
    <dialog id="finish-modal">
      <svg @click="closeModal('finish-modal');" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
      <h2>Notice</h2>
      <div>
        When you click the button below you will generate a report of this activity.
      </div>
      <div>
        This will conclude the usuage and you will <b>NOT</b> be able to return to this activity usuage.
      </div>
      <button v-if="!loadingConfigureReport" @click="finishUsuage">
        Configure Report
      </button>
      <button v-else>
        Processing...
        <b-spinner small></b-spinner>
      </button>
    </dialog>
    <div id="container" v-if="activityID">
      <div v-if="!showReport">
        <div id="sidebar">
          <h2>{{ applicationInfo.title }}</h2>
          <button v-if="!loadingSaveQuestionResults" style="width: 100%; margin: 5px 0;" @click="saveQuestionResults">
            Save
          </button>
          <button v-else style="width: 100%; margin: 5px 0">
            Saving...
          </button>
          <div
            @click="switchQuestionIndex(-1); setConditionalSkip()"
            :class="[
              currentQuestionIndex == -1 ? 'selected-question' : null,
              'questionNavBar'
            ]"
            style="text-align: center; font-weight: 700; font-size: 1.2rem"
          >
            Introduction
          </div>
          <hr style="border: solid black 1px;" />
          <div v-for="(item,index) in questionsInfo" :key="index" 
            @click="switchQuestionIndex(index); setConditionalSkip()"
            :class="[
              currentQuestionIndex == index ? 'selected-question' : null,
              'questionNavBar',
              determineScoreStyleClass(item)
            ]"
          >
            {{ `${index+1}) ${item.question}` }}
          </div>
          <hr style="border: solid black 1px;" />
          <div
            @click="switchQuestionIndex(questionsInfo.length); setConditionalSkip()"
            :class="[
              currentQuestionIndex == questionsInfo.length ? 'selected-question' : null,
              'questionNavBar'
            ]"
            style="text-align: center; font-weight: 700; font-size: 1.2rem"
          >
            Final Page
          </div>
        </div>
        <div id="main-box">
          <div v-if="currentQuestionIndex < questionsInfo.length && currentQuestionIndex >= 0" id="main-grid">
            <div>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/left-circle.svg" @click="switchQuestionIndex(currentQuestionIndex - 1); setConditionalSkip()" />
              </span>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/right-circle.svg" @click="switchQuestionIndex(currentQuestionIndex + 1); setConditionalSkip()" />
              </span>
              <span class="prev-ques-nav-buttons">
                <img src="../images/icons_svg/general/rotate-circle.svg" />
              </span>
            </div>
            <div style="text-align: center;">
              {{ questionsInfo[currentQuestionIndex].question }}
            </div>
            <div style="display: flex; justify-content: center; align-items: center;">
<!--               <span class="preview-icon-container">
                <img src="../images/icons_svg/general/student-graduation.svg" class='preview-icons'/>
                <div>Child View</div>
              </span> -->
            </div>
            <div style="display: flex; flex-direction: column;">
              <div style="font-size: .9rem;">
                <div style="margin-top: .5rem;">{{ `Q. ${currentQuestionIndex+1}` }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Area:</span> {{ questionsInfo[currentQuestionIndex].area }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Type:</span> {{ questionsInfo[currentQuestionIndex].type }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Category:</span> {{ questionsInfo[currentQuestionIndex].category }}</div>
                <div><span style="margin-top: 1rem; text-decoration: underline;">Subcategory:</span> {{ questionsInfo[currentQuestionIndex].sub_category }}</div>
                <div style="margin-top: 1rem">
                  <span>
                    <span style="text-decoration: underline;">Question ID:</span>
                    ...{{ questionsInfo[currentQuestionIndex].question_id.slice(-4) }}
                  </span>
                  <div>
                    <span>
                      <span style="text-decoration: underline;">Custom QID:</span>
                      ...{{ questionsInfo[currentQuestionIndex].custom_id.slice(-4) }}
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; flex-direction: column;">
                <div v-for="(item, index) in questionsInfo[currentQuestionIndex].specialistButtonsConfig" :key="index">
                  <button v-if="index % 2 === 0" class="exampleButton">{{ item.text }}</button>
                </div>
              </div>
            </div>
            <div class="border-color-primary" id="preview-screen-specialist" :style="{backgroundColor:questionsInfo[currentQuestionIndex].background_color, position: 'relative', height: '500px'}">
              <div v-for="(image, index) in questionsInfo[currentQuestionIndex].child_images" :key="`preview-screen-image${index}`"
                :style="{
                  top: `${image.y}px`,
                  left: `${image.x}px`,
                  width: `${image.width}px`,
                  height: `${image.height}px`,
                  backgroundColor: image.background_color,
                  zIndex: image.zIndex,
                }"
                class="final-image-container"
              >
                <img v-if="image.fileRef" :src="`${reverseProxy}/api/${image.fileRef}`" alt="Picture N/A" width="100%" height="100%"/>
              </div>
              <div v-for="(button, index) in questionsInfo[currentQuestionIndex].child_buttons" :key="`preview-screen-button${index}`"
                :style="{
                  top: `${button.y}px`,
                  left: ` ${button.x}px`,
                  width: `${button.width}px`,
                  height: `${button.height}px`,
                  backgroundColor: button.background_color,
                  zIndex: button.zIndex,
                  fontSize: `${button.fontSize}px`,
                }"
                class="final-button-container"
              >
                <img v-if="button.fileRef" :src="`${reverseProxy}/api/${button.fileRef}`" alt="Picture N/A" width="100%" height="100%"/>
                <div class="placeholder-rect">{{ button.text }}</div>
              </div>
            </div>
            <div style="display: flex; flex-direction: column;">
              <div style="font-size: .9rem; margin: 1rem">
                <div class="typicalDuration">Typ: {{ questionsInfo[currentQuestionIndex].typical_duration }}</div>
                <div class="timeOut">Time Out: {{ questionsInfo[currentQuestionIndex].time_out }}</div>
                <div class="totalDuration">Duration: {{ questionsInfo[currentQuestionIndex].time_out }}</div>
              </div>
              <div class="d-flex flex-column">
                <div v-for="(item, index) in questionsInfo[currentQuestionIndex].specialistButtonsConfig" :key="index">
                  <button v-if="index % 2 !== 0" class="exampleButton">{{ item.text }}</button>
                </div>
              </div>
            </div>
            <div class="icons-grid">
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/question-circle.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/video.svg" class='preview-icons'/>
                <div>Left</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/video-off.svg" class='preview-icons'/>
                <div>Center</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/video.svg" class='preview-icons'/>
                <div>Right</div>
              </span>
              <div class="d-inline-block">
                <div @click="scoreQuestion(questionsInfo[currentQuestionIndex], 0)"
                  :class="[
                    'circle-button',
                    'red-button',
                    0 == questionsInfo[currentQuestionIndex].questionResult.selected_score ? 'selected-score-button' : null
                  ]"
                >
                  0
                </div>
              </div>
              <div v-for="n in questionsInfo[currentQuestionIndex].highest_score_possible" :key="n" class="d-inline-block">
                <div @click="scoreQuestion(questionsInfo[currentQuestionIndex], n)"
                  :class="[
                    'circle-button',
                    n == questionsInfo[currentQuestionIndex].highest_score_possible ? 'greenFull-button' : 'greenLight-button',
                    n == questionsInfo[currentQuestionIndex].questionResult.selected_score ? 'selected-score-button' : null
                  ]"
                >
                  {{ `+${n}` }}
                </div>
              </div>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/audio-file.svg" class='preview-icons'/>
                <div>Child Prompts</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/info-circle.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/list-edit.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/lightbulb.svg" class='preview-icons'/>
                <div>Specialist Prompt</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/mike.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/camera.svg" class='preview-icons'/>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/play.svg" class='preview-icons'/>
                <div>Instruction</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/eye-tracking.svg" class='preview-icons'/>
                <div>Eye-tracking</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/head-eeg.svg" class='preview-icons'/>
                <div>EEG</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/arm-emg.svg" class='preview-icons'/>
                <div>EMG</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/heart-pulse.svg" class='preview-icons'/>
                <div>ECG</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/augment-reality.svg" class='preview-icons'/>
                <div>Augmented Reality</div>
              </span>
              <span class="preview-icon-container">
                <img src="../images/icons_svg/general/virtual-reality.svg" class='preview-icons'/>
                <div>Virtual Reality</div>
              </span>
            </div>
          </div>
          <div v-else-if="currentQuestionIndex < 0">
            <h1>Introduction</h1>
            <div>
              Application Title: {{ applicationInfo.title }}
            </div>
            <div>
              Activity ID: {{ this.activityData.activity_id }}
            </div>
            <div>
              Child ID: {{ this.activityData.child_id }}
            </div>
            <div>
              Start Date: {{ formatTimestamp(this.purchaseData.start_date) }}
            </div>
            <div>
              Total Test Time: {{ tempActivityTime.totalDurationElaspedTime }}
            </div>
            <div>
              <button @click="openUpChildView">Open Up Seperate Tab</button>
            </div>
            <div>
              <button @click="switchQuestionIndex(0)">Start</button>
            </div>
          </div>
          <div v-else id="finish-box">
            <div><button style="width: 100%;" @click="openModal('finish-modal')">Continue to Report</button></div>
            <div class="score-legend">
              <span>Full:<span class="finish-question-legend-squares score-greenFull"></span></span>
              <span>Partial: <span class="finish-question-legend-squares score-greenLight"></span></span>
              <span>Zero: <span class="finish-question-legend-squares score-zero"></span></span>
              <span>Skipped: <span class="finish-question-legend-squares score-skip"></span></span>
            </div>
            <span v-for="(item,index) in questionsInfo" :key="index" 
              @click="switchQuestionIndex(index)"
              :class="[
                'finish-question-squares',
                determineScoreStyleClass(item)
              ]"
            >
              {{ index+1 }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios.js';

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        
        activityData: null,
        purchaseData: null,
        applicationInfo: null,
        questionsInfo: null,
        questionResultData: null,

        activityID: null,
        currentQuestionIndex: -1,
        previousQuestionIndex: -1,
        showReport: false,

        loadingConfigureReport: false,
        loadingSaveQuestionResults: false,

        specialistChannelOpen: false,
        channel: null,

        tempActivityTime: {
          totalDuration: null,
          totalDurationElaspedTime: null
        },
      }
    },
    async created() {
      function placeInArray(arr, value, variableToCheck, findOrder) {
        let low = 0;
        let high = arr.length - 1;
        // Binary search to find the insertion point
        while (low <= high) {
          const mid = Math.floor((low + high) / 2);
          if (arr[mid][variableToCheck] < findOrder) {
            low = mid + 1;
          } else {
            high = mid - 1;
          }
        }

        // If the value is not in the array, insert it at the correct position
        arr.splice(low, 0, value);
        return arr;
      }
      try {
        let activityData = await instance.get(`/api/activity/${this.$route.params.activityID}`);
        this.activityData = activityData.data;
        let purchaseData = await instance.get(`/api/user-app-purchased-junction/${this.activityData.purchase_id}`);
        this.purchaseData = purchaseData.data;
        let applicationResponse = await instance.get(`/api/appAdmin/application/${this.purchaseData.application_id}`);
        this.applicationInfo = applicationResponse.data;
        let questionsResponse = await instance.get(`/api/question-admin/application/${this.applicationInfo.application_id}`);
        let questionResponse = questionsResponse.data;
        let questionResultResponse = await instance.get(`/api/question-result/activity/${this.$route.params.activityID}`);
        this.questionResultData = questionResultResponse.data;
        
        let result = [];
        for (let i = 0; i < questionResponse.length; i++) {
          placeInArray(result, {
            ...questionResponse[i],
            child_buttons: JSON.parse(questionResponse[i].child_buttons),
            specialist_buttons: JSON.parse(questionResponse[i].specialist_buttons),
            child_images: JSON.parse(questionResponse[i].child_images),

            //temporary variables not part of the post request
            typicalDurationTimer: null,
            timeOutTimer: null,
            questionDuration: null,
            typicalDurationTimerElapsedTime: parseInt(questionResponse[i].typical_duration),
            timeOutTimerElapsedTime: parseInt(questionResponse[i].time_out),
            questionDurationTimerElapse: questionResponse[i].total_duration,
          }, 'question_order', questionResponse[i].question_order);
        }
        this.activityID = this.$route.params.activityID;
        
        const resultLookup = this.questionResultData.reduce((acc, qr) => {
          acc[qr.question_reference_id] = qr;
          return acc;
        }, {});
        const nestedQuestions = result.map((question) => ({
          ...question,
          questionResult: resultLookup[question.question_id] || null,
        }));
        this.questionsInfo = nestedQuestions;

        if (questionResponse.length > 0) {
          this.formatForNewResolution('preview-screen-specialist');
        }

        this.tempActivityTime = {
          totalDuration: null,
          totalDurationElaspedTime: this.activityData.total_duration
        }
        //this.startStopWatch(this.activityData, )

      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      switchQuestionIndex(index) {
        this.previousQuestionIndex = this.currentQuestionIndex;
        this.currentQuestionIndex = index;
        if (this.channel) {
          this.sendChannelMessage({
            action: 'changeIndex',
            data: index
          });
        }
        if (index < this.questionsInfo.length && index >= 0) {
          this.formatForNewResolution('preview-screen-specialist');
        }
      },
      getImageFileSrc(imageDetailObject) {
        if (imageDetailObject.fileRef != null && imageDetailObject.fileRef != "") {
          return imageDetailObject.fileRef;
        } else if (imageDetailObject.file != null) {
          return URL.createObjectURL(imageDetailObject.file);
        } else {
          return null;
        }
      },
      scoreQuestion(question, currentScore) {
        this.$forceUpdate()
        question.questionResult.selected_score = currentScore;
        question.questionResult.skipped = false;
      },
      determineScoreStyleClass(question) {
        if (question.questionResult.skipped) {
          return 'score-skip';
        } else if (question.questionResult.selected_score == question.highest_score_possible) {
          return 'score-greenFull';
        } else if (question.questionResult.selected_score == 0) {
          return 'score-zero';
        } else if (question.questionResult.selected_score > 0 && question.highest_score_possible > question.questionResult.selected_score) {
          return 'score-greenLight';
        } else {
          return '';
        }
      },
      formatTimestamp(timestamp) {
        if (timestamp == null) {
          return 'null';
        }

        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      addTimeToInterval(interval, hoursToAdd = 0, minutesToAdd = 0, secondsToAdd = 0) {
        let [hh, mm, ss] = interval.split(":").map(Number);

        ss += secondsToAdd;
        mm += minutesToAdd;
        hh += hoursToAdd;

        if (ss >= 60) {
          mm += Math.floor(ss / 60);
          ss = ss % 60;
        } else if (ss < 0) {
          mm -= Math.ceil(Math.abs(ss) / 60);
          ss = 60 + (ss % 60);
        }

        if (mm >= 60) {
          hh += Math.floor(mm / 60);
          mm = mm % 60;
        } else if (mm < 0) {
          hh -= Math.ceil(Math.abs(mm) / 60);
          mm = 60 + (mm % 60);
        }

        return [
          String(hh).padStart(2, "0"),
          String(mm).padStart(2, "0"),
          String(ss).padStart(2, "0")
        ].join(":");
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          if (!document.getElementById(elementID)) {
            return;
          }

          let currentQuestionInstance = this.questionsInfo[this.currentQuestionIndex];
          let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
          let newWidth = document.getElementById(elementID).offsetWidth;
          let newHeight = document.getElementById(elementID).offsetHeight;
          if (newWidth == originalWidth && newHeight == originalHeight) {
            return;
          }

          //[x,y] transform coordinates from original to new resolution
          let xTransform = newWidth / originalWidth;
          let yTransform = newHeight / originalHeight;

          for (let i = 0; i < currentQuestionInstance.child_buttons.length; i++) {
            currentQuestionInstance.child_buttons[i].x *= xTransform;
            currentQuestionInstance.child_buttons[i].y *= yTransform;
            currentQuestionInstance.child_buttons[i].height *= yTransform;
            currentQuestionInstance.child_buttons[i].width *= xTransform;
          }

          for (let i = 0; i < currentQuestionInstance.child_images.length; i++) {
            currentQuestionInstance.child_images[i].x *= xTransform;
            currentQuestionInstance.child_images[i].y *= yTransform;
            currentQuestionInstance.child_images[i].height *= yTransform;
            currentQuestionInstance.child_images[i].width *= xTransform;
          }

          currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
        });

      },
      startStopWatch(questionObject, propertyStopWatchName, propertyStopWatchtime) {
        questionObject[propertyStopWatchName] = setInterval(() => {
          questionObject[propertyStopWatchtime] = this.addTimeToInterval(questionObject[propertyStopWatchtime], 0, 0, 1);
        }, 1000);
      },
      stopStopWatch(questionObject, propertyStopWatchName) {
        clearInterval(questionObject[propertyStopWatchName]);
        questionObject[propertyStopWatchName] = null;
      },
      resetStopWatch(questionObject, propertyStopWatchName, propertyStopWatchtime) {
        questionObject[propertyStopWatchtime] = 0;
        this.stopStopWatch(questionObject, propertyStopWatchName);
        this.startStopWatch(questionObject, propertyStopWatchName, propertyStopWatchtime);
      },
      startTimer(questionObject, propertyTimerName, propertyTimerTime) {
        questionObject[propertyTimerName] = setInterval(() => {
          let temp = questionObject[propertyTimerTime];
          if (temp - 1 < 0) {
            this.stopTimer(questionObject, propertyTimerName);
          }
          else {
            questionObject[propertyTimerTime]--;
          }
        }, 1000);
      },
      stopTimer(questionObject, propertyTimerName) {
        clearInterval(questionObject[propertyTimerName]);
        questionObject[propertyTimerName] = null;
      },
      resetTimer(questionObject, timerName, timerElapseTimeName, originalTimeName) {
        let questionFunctions = questionObject;
        questionFunctions[timerElapseTimeName] = questionObject[originalTimeName];
        this.stopTimer(questionFunctions, timerName);
        this.startTimer(questionFunctions, timerName, timerElapseTimeName);
      },
      previewTimingPack(questionObject, setting) {
        let questionFunctions = questionObject;
        //turn on timings
        if (setting) {
          this.startTimer(questionFunctions, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime');
          this.startTimer(questionFunctions, 'timeOutTimer', 'timeOutTimerElapsedTime');
          this.startStopWatch(questionFunctions, 'questionDuration', 'questionDurationTimerElapse');
        }
        else {
          this.stopTimer(questionFunctions, 'typicalDurationTimer');
          this.stopTimer(questionFunctions, 'timeOutTimer');
          this.stopStopWatch(questionFunctions, 'questionDuration');
        }
      },
      previewTimingResetPack(questionObject) {
        this.resetTimer(questionObject, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime', 'typicalDuration');
        this.resetTimer(questionObject, 'timeOutTimer', 'timeOutTimerElapsedTime', 'timeOut');
        this.resetStopWatch(questionObject, 'questionDuration', 'questionDurationTimerElapse');
      },
      setConditionalSkip() {
        if (this.previousQuestionIndex >= this.questionsInfo.length || this.previousQuestionIndex < 0) {
          return;
        }
        if (this.questionsInfo[this.previousQuestionIndex].questionResult.selected_score != null) {
          this.questionsInfo[this.previousQuestionIndex].questionResult.skipped = false;
        } else {
          this.questionsInfo[this.previousQuestionIndex].questionResult.skipped = true;
        }
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      async saveQuestionResults() {
        try {
          this.loadingSaveQuestionResults = true;
          let questionResultArray = [];
          for (let i = 0; i < this.questionsInfo.length; i++) {
            questionResultArray.push({
              question_result_id: this.questionsInfo[i].questionResult.question_result_id,
              notes: this.questionsInfo[i].questionResult.notes,
              selected_score: this.questionsInfo[i].questionResult.selected_score,
              child_selected_answer: this.questionsInfo[i].questionResult.child_selected_answer,
              correct_answer: this.questionsInfo[i].questionResult.correct_answer,
              audio_clips: this.questionsInfo[i].questionResult.audio_clips,
              video_clips: this.questionsInfo[i].questionResult.video_clips,
              picture_clips: this.questionsInfo[i].questionResult.picture_clips,
              prompt_clicks: this.questionsInfo[i].questionResult.prompt_clicks,
              repeat_clicks: this.questionsInfo[i].questionResult.repeat_clicks,
              total_duration: this.questionsInfo[i].questionResult.total_duration,
              ecg: this.questionsInfo[i].questionResult.ecg,
              emg: this.questionsInfo[i].questionResult.emg,
              motor_sensor_left: this.questionsInfo[i].questionResult.motor_sensor_left,
              motor_sensor_right: this.questionsInfo[i].questionResult.motor_sensor_right,
              prompt_count: this.questionsInfo[i].questionResult.prompt_count,
              hint_count: this.questionsInfo[i].questionResult.hint_count,
              repeat_count: this.questionsInfo[i].questionResult.repeat_count,
              over_time: this.questionsInfo[i].questionResult.over_time,
              skipped: this.questionsInfo[i].questionResult.skipped
            });
          }
          await instance.patch(`/api/question-result/batch`, questionResultArray);
          this.loadingSaveQuestionResults = false;
          alert("Activity Saved");
        } catch (e) {
          this.loadingSaveQuestionResults = false;
          console.error(e);
        }
      },
      async finishUsuage() {
        try {
          this.loadingConfigureReport = true;
          let questionResultArray = [];
          for (let i = 0; i < this.questionsInfo.length; i++) {
            questionResultArray.push({
              question_result_id: this.questionsInfo[i].questionResult.question_result_id,
              notes: this.questionsInfo[i].questionResult.notes,
              selected_score: this.questionsInfo[i].questionResult.selected_score,
              child_selected_answer: this.questionsInfo[i].questionResult.child_selected_answer,
              correct_answer: this.questionsInfo[i].questionResult.correct_answer,
              audio_clips: this.questionsInfo[i].questionResult.audio_clips,
              video_clips: this.questionsInfo[i].questionResult.video_clips,
              picture_clips: this.questionsInfo[i].questionResult.picture_clips,
              prompt_clicks: this.questionsInfo[i].questionResult.prompt_clicks,
              repeat_clicks: this.questionsInfo[i].questionResult.repeat_clicks,
              total_duration: this.questionsInfo[i].questionResult.total_duration,
              ecg: this.questionsInfo[i].questionResult.ecg,
              emg: this.questionsInfo[i].questionResult.emg,
              motor_sensor_left: this.questionsInfo[i].questionResult.motor_sensor_left,
              motor_sensor_right: this.questionsInfo[i].questionResult.motor_sensor_right,
              prompt_count: this.questionsInfo[i].questionResult.prompt_count,
              hint_count: this.questionsInfo[i].questionResult.hint_count,
              repeat_count: this.questionsInfo[i].questionResult.repeat_count,
              over_time: this.questionsInfo[i].questionResult.over_time,
              skipped: this.questionsInfo[i].questionResult.selected_score == null ? true : false
            });
          }
          await instance.patch(`/api/question-result/batch`, questionResultArray);
          await instance.patch(`/api/activity/${this.activityData.activity_id}`, {
            total_duration: '0 seconds',
            finish_date: new Date().toISOString(),
          })
          this.$router.push(`/activity/report/${this.$route.params.activityID}`);
          this.loadingConfigureReport = false;
        } catch (e) {
          this.loadingConfigureReport = false;
          console.error(e);
        }
      },
      openUpChildView() {
        window.open(this.$router.resolve({ path: `/activity/childView/${this.activityID}` }).href, '_blank');

        if (!this.specialistChannelOpen) {
          this.channel = new BroadcastChannel(`${this.activityID}`);

          this.channel.addEventListener('message', this.receiveChannelMessage);

          this.specialistChannelOpen = true;
        }
      },
      receiveChannelMessage(event) {
        console.log('Received message:', event);
      },
      sendChannelMessage(message) {
        this.channel.postMessage(message);
      }
    },
    beforeDestroy() {
      if (this.specialistChannelOpen) {
        this.channel.removeEventListener('message', this.receiveMessage);
        this.channel.close();
      }
      clearInterval(this.tempActivityTime.totalDuration);
      for (let i = 0; i < this.questionsInfo.length; i++) {
        if (this.questionsInfo[i].typicalDurationTimer) {
          clearInterval(this.questionsInfo[i].typicalDurationTimer);
        }
        if (this.questionsInfo[i].timeOutTimer) {
          clearInterval(this.questionsInfo[i].timeOutTimer);
        }
        if (this.questionsInfo[i].questionDuration) {
          clearInterval(this.questionsInfo[i].questionDuration);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  $sidebar-width: 300px;
  $reportOrange: #FF9B00;
	$reportOrangeLight: #eecc9a;
  $greenFull: #ace2c6;
  $greenLight: #D9F2E6;
  $redZero: #FFBCBC;
  $greySkip: #ECECEC;

  #container {
    font-family: 'Roboto', sans-serif;
    width: 100%;
    position: relative;

    h2 {
      text-align: center;
    }

    .score-greenFull {
      background-color: $greenFull;
    }

    .score-greenLight {
      background-color: $greenLight;
    }

    .score-zero {
      background-color: $redZero;
    }

    .score-skip {
      background-color: $greySkip;
    }
  }

  #sidebar {
    border-right: solid $reportOrange 1px;
    width: $sidebar-width;
    position: fixed;
    overflow-y: auto;
    height: calc(100dvh - #{globalSharedVariables.$navbar-height});

    .questionNavBar {
      cursor: pointer;
      padding: .5rem;

      &:hover {
        background-color: $reportOrangeLight;
      }
    }

    .selected-question {
      background-color: $reportOrange;
    }
  }

  #main-box {
    margin-left: $sidebar-width;
    padding: 1rem;

    #main-grid {
      display: grid;
      grid-template-columns: 1fr 3fr 1fr;

      .prev-ques-nav-buttons {
        cursor: pointer;
        padding: 0;
        margin: 0 2px;

        img {
          width: 30px;
          border-radius: 50rem;

          &:hover {
            background-color: $reportOrange;
          }
        }
      }

      .border-color-primary {
        border: solid 2px $reportOrange;
        width: 100%;
        position: relative;

        > div {
          position: absolute;
        }

        .resizable-button-container, .final-button-container {
          $local-border-radius: 1rem;

          position: absolute;
          border-radius: $local-border-radius;
          box-shadow: 0 0 5px 5px lightgrey;
          border: solid black 1px;
          user-select: none;
          cursor: pointer;
          
          .placeholder-rect {
            position: absolute;
            top: 0;
            left: 0;
            word-wrap: break-word;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          img {
            border-radius: $local-border-radius;
          }
        }
      }

      .icons-grid {
        margin-top: 1rem;
        grid-column: span 3;
        display: grid;
        grid-template-columns: repeat(11, auto);
      }

      .preview-icon-container {
        font-size: xx-small;
        text-align: center;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 50px;
        width: 50px;
        cursor: pointer;

        .preview-icons {
          width: 50px;
          height: 24px;
        }

        &:hover {
          opacity: .8;
        }

        div {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, 50%);
        }
      }

      .circle-button {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .greenFull-button {
        box-shadow: inset 0 0 2px 2px $greenFull;
        color: $greenFull;
        border: 1px solid green;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenFull;
        }

        &.selected-score-button {
          background-color: $greenFull;
        }
      }

      .greenLight-button {
        box-shadow: inset 0 0 2px 2px $greenLight;
        color: $greenLight;
        border: 1px solid rgb(0, 156, 0);
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenLight;
        }

        &.selected-score-button {
          background-color: $greenLight;
        }
      }

      .red-button {
        box-shadow: inset 0 0 2px 2px $redZero;
        color: $redZero;
        border: 1px solid red;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $redZero;
        }

        &.selected-score-button {
          background-color: $redZero;
        }
      }
    }

    #finish-box {
      .score-legend {
        display: flex;

        > span {
          margin-right: .5rem;
          display: flex;
          align-items: center;
        }
      }
      
      .finish-question-squares {
        cursor: pointer;
        margin: .3rem;
        width: 50px;
        height: 50px;
        border-radius: 5px;
        border: solid black 1px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      .finish-question-legend-squares {
        margin: .3rem;
        width: 25px;
        height: 25px;
        border-radius: 5px;
        border: solid black 1px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
    }

    .typicalDuration {
      border: solid #FAFD5F 2px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .timeOut {
      border: solid #2B870B 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
    }

    .totalDuration {
      border: solid black 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
    }

  }

  #finish-modal {
    h2 {
      text-align: center;
    }

    b {
      color: red;
    }
  }
</style>